module.exports = __webpack_public_path__ + "static/media/dotted-pattern.87c8434b.png";